// ── Types ─────────────────────────────────────────────────────────────────────

export interface EmailAnalyticsSummary {
  totalSent: number;
  totalOpened: number;
  totalClicked: number;
  openRate: number;
  clickRate: number;
  periodDays: number;
  /** Sends in the period that SES reported as bounced. */
  bounced?: number;
  /** Sends in the period whose recipient marked them as spam. */
  complained?: number;
}

export interface EmailDailyCount {
  date: string;
  sent: number;
  opened: number;
  clicked: number;
}

export interface EmailTemplateStats {
  templateKey: string;
  sent: number;
  opened: number;
  clicked: number;
  openRate: number;
  clickRate: number;
}

export interface EmailAnalyticsData {
  summary: EmailAnalyticsSummary;
  dailyCounts: EmailDailyCount[];
  byTemplate: EmailTemplateStats[];
}

// ── Action types ──────────────────────────────────────────────────────────────

export enum ActionTypes {
  FETCH_ANALYTICS_REQUEST = 'emailAnalytics/fetchRequest',
  FETCH_ANALYTICS_SUCCESS = 'emailAnalytics/fetchSuccess',
  FETCH_ANALYTICS_FAILURE = 'emailAnalytics/fetchFailure',
}

// ── Action interfaces ─────────────────────────────────────────────────────────

export type FetchAnalyticsRequestAction = {
  type: ActionTypes.FETCH_ANALYTICS_REQUEST;
  payload: { periodDays: number };
}
export type FetchAnalyticsSuccessAction = {
  type: ActionTypes.FETCH_ANALYTICS_SUCCESS;
  payload: EmailAnalyticsData;
}
export type FetchAnalyticsFailureAction = {
  type: ActionTypes.FETCH_ANALYTICS_FAILURE;
  payload: string;
}

export type EmailAnalyticsAction =
  | FetchAnalyticsRequestAction
  | FetchAnalyticsSuccessAction
  | FetchAnalyticsFailureAction;

// ── Action creators ───────────────────────────────────────────────────────────

export const fetchAnalyticsRequest = (periodDays: number = 30): FetchAnalyticsRequestAction => ({
  type: ActionTypes.FETCH_ANALYTICS_REQUEST,
  payload: { periodDays },
});

export const fetchAnalyticsSuccess = (data: EmailAnalyticsData): FetchAnalyticsSuccessAction => ({
  type: ActionTypes.FETCH_ANALYTICS_SUCCESS,
  payload: data,
});

export const fetchAnalyticsFailure = (error: string): FetchAnalyticsFailureAction => ({
  type: ActionTypes.FETCH_ANALYTICS_FAILURE,
  payload: error,
});
